import axios from 'axios';
import * as types from '../actionTypes';
import * as urls from '../urlTypes';
import { toastError } from '../../util/toastUtils';
import { _updateTargetLabelsExp } from '../../util/deUtils';

export const getTargetExpression = async targetId => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/labelExpression/${targetId}`;

  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    const responseType = typeof response.data;
    if (response.data.status === 500) {
      toastError(response.data.message);
      return false;
    }
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get target expressions');
    return false;
  }
};

// set selected target in Label Screen

export const setActiveTargetToLabel = target => dispatch => {
  dispatch({
    type: types.SET_TARGET_LABEL,
    payload: target,
  });
};

export const setActivetargetLabel = target => async dispatch => {
  const labelExpression = await getTargetExpression(target.id);
  if (!labelExpression.error) {
    dispatch({
      type: types.SET_TARGET_LABEL_EXPRESSION,
      payload: labelExpression || [],
    });
  }
};

export const saveTargetExpLabel = async (targetId, payload) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/labelExpression/${targetId}`;

  try {
    const response = await axios({
      url,
      method: 'put',
      responseType: 'json',
      withCredentials: true,
      data: payload,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to save target label.');
    return false;
  }
};

export const saveTargetLabel = target => async (dispatch, getState) => {
  const state = getState();
  const selectedTarget = state.deLabel.selectedTargets;
  const originalLabelExp = state.deLabel.targetExpression;
  const updatedLabelExp = _updateTargetLabelsExp(originalLabelExp, target);
  const saveResponse = await saveTargetExpLabel(
    selectedTarget.id,
    updatedLabelExp
  );
  if (saveResponse.status === 'Success') {
    dispatch({
      type: types.SET_TARGET_LABEL_EXPRESSION,
      payload: updatedLabelExp,
    });
  } else {
    dispatch({
      type: types.SET_TARGET_LABEL_EXPRESSION,
      payload: originalLabelExp,
    });
    toastError('Failed to save target label.');
  }
};

export const initiateExportTarget = async targetId => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/exportReport/${targetId}`;

  try {
    const response = await axios({
      url,
      method: 'post',
      responseType: 'json',
      withCredentials: true,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to export target.');
    return false;
  }
};

export const exportTarget = selectedTarget => async (dispatch, getState) => {
  const state = getState();
  const target = selectedTarget || state.deLabel.selectedTargets;
  const exportResponse = await initiateExportTarget(target.id);
  if (exportResponse) {
    dispatch({
      type: types.DE_EXPORT_TARGET,
      payload: exportResponse.data,
    });
  }
};
